module.exports = __webpack_public_path__ + "img/strengthBackground.0a332092.png";